import type { SettingListItem } from './system-parameters.api';

export const AUTO_CLOSE_KEY = 'order.auto_close_enabled';

/** Same reading as the API's `getAutoCloseEnabled`: ON unless the stored value is `false`/`'false'`. */
export function isAutoCloseEnabled(settings: readonly SettingListItem[]): boolean {
  const value = settings.find((item) => item.key === AUTO_CLOSE_KEY)?.value;

  return value !== false && value !== 'false';
}
